import { instance } from '@/services/avik-api-gateway'
import { SearchDelay } from '@/types/search-delay'
import { AxiosResponse } from 'axios'

export interface SearchDelayParams {
  technical: string | number
  departureDate: string
}

export interface SearchDelayParams2 {
  trainId: string
  departureDate: string
}

export function searchDelay(
  params: SearchDelayParams
): Promise<AxiosResponse<SearchDelay[]>> {
  return instance.get(`/search/delay`, {
    params,
  })
}

export function searchDelay2(
  params: SearchDelayParams2
): Promise<AxiosResponse<SearchDelay[]>> {
  return instance.get('/graph/train-search/right-panel', {
    params,
  })
}
